<template>
  <component
    :is="isMegaMenuMobile ? LazyCmsMegaMenuL1Mobile : LazyCmsMegaMenuL1Desktop"
    v-bind="{ content }"
    @click="handleClick"
    @expand="handleClickCollapse"
  />
</template>

<script lang="ts" setup>
import type { MenuItem } from '#types/components/cms/mega-menu'
import { LazyCmsMegaMenuL1Desktop, LazyCmsMegaMenuL1Mobile } from '#components'
import { MegaMenuL1ContextKey, MegaMenuMobileContextKey } from '#content/contexts/megamenu'

const props = defineProps<{ content: MenuItem }>()

const { $gtm } = useNuxtApp()

const eventLabel = props.content.delocalizedTracking || props.content.name
provide(MegaMenuL1ContextKey, eventLabel)

const isMegaMenuMobile = inject(MegaMenuMobileContextKey, false)

const handleClick = () => $gtm.push('topNav.onClickTopNavLink', eventLabel)
const handleClickCollapse = () => $gtm.push('topNav.onClickMobileMenuSection', eventLabel)
</script>
